// BGM配置文件
// 当添加新的BGM文件时，需要在此文件中添加对应的配置

const bgmConfig = [
  {
    name: '背景音乐1',
    file: '背景音乐1.mp3',
    path: '/res/sound/hallbgm/背景音乐1.mp3'
  },
  {
    name: '背景音乐2',
    file: '背景音乐2.mp3',
    path: '/res/sound/hallbgm/背景音乐2.mp3'
  },
  {
    name: '背景音乐3',
    file: '背景音乐3.mp3',
    path: '/res/sound/hallbgm/背景音乐3.mp3'
  },
  {
    name: '背景音乐4',
    file: '背景音乐4.mp3',
    path: '/res/sound/hallbgm/背景音乐4.mp3'
  }
  // 添加新BGM时，按照以下格式添加：
  // {
  //   name: 'BGM名称',
  //   file: '文件名.mp3',
  //   path: '/res/sound/hallbgm/文件名.mp3'
  // }
]

export default bgmConfig

